import { configureStore } from '@reduxjs/toolkit';
import LoginReducers from './Slice/login_logoutSclice';
import FoodReducer from './Slice/foodSlice';

export const store = configureStore({
    reducer: {
        login: LoginReducers,
        food: FoodReducer,

    },
    devTools: true
});